'use client'

import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { useSession } from 'session/src/hooks/useSession'

import { ModalUserInfo } from '../ModalUserInfo/ModalUserInfo'

import styles from './AccountName.module.scss'
import text from 'fukku/styles/texts.module.scss'

export const AccountName = () => {
	const { name, email } = useSession()

	const userName = name || email?.split('@')[0]
	const { isSmall } = useResponsive()

	return (
		userName && (
			<div className={styles.nameContainer}>
				<p className={`${text.inspirationalTitleM} ${styles.name}`}>
					{userName}
				</p>
				{isSmall && <ModalUserInfo userName={userName} />}
			</div>
		)
	)
}
